module.exports = __webpack_public_path__ + "img/logo-nedetel.33fe45f6.png";